<template>
    <div
        class="basic-select"
        :tabindex="tabindex"
        @blur="closeOptions"
        ref="wrapper"
    >
        <div
            :class="[
                'select-head',
                { 'has-error': hasError && showErrorRequired },
            ]"
            ref="head"
        >
            <span
                v-if="!optionShown && selectionMade != ''"
                @click.stop="
                    () => {
                        test(), $refs.searchInput.focus();
                    }
                "
            >
                <i
                    v-if="selected"
                    :class="[
                        'flag-icon',
                        'flag',
                        `flag-icon-${selected.iso.toLowerCase()}`,
                    ]"
                    style="margin: 0 5px"
                ></i>
                {{ selectionMade }}
                <img
                    v-if="selected"
                    src="@/assets/images/CHECK-Mark.svg"
                    style="width: 15px"
                />
            </span>

            <input
                v-bind="$attrs"
                type="text"
                ref="searchInput"
                v-model="search"
                @focus="showOptions"
                @input="checkLang"
                :placeholder="placeholder"
                :disabled="disabled"
                autocomplete="new-password"
            />
        </div>
        <span
            class="option-indicator"
            ref="indicator"
            @click="
                () => {
                    showOptions, $refs.searchInput.focus();
                }
            "
            v-if="!disabled"
        ></span>
        <ul ref="optionList">
            <template v-if="filtered.length">
                <li
                    v-for="(option, index) in filtered"
                    :key="index"
                    :data-value="option.iso"
                    @click="setSelection(option.nice_name, option.id, option)"
                >
                    <span
                        v-if="showFlag"
                        :class="[
                            'flag-icon',
                            'flag',
                            `flag-icon-${option.iso.toLowerCase()}`,
                        ]"
                    ></span>
                    {{ option.nice_name }}
                </li>
            </template>
            <template v-else>
                <div style="margin: 10px 0">
                    {{ $t("This country not available") }}
                </div>
            </template>
        </ul>
        <p
            v-if="showErrorRequired"
            :class="['error-message', { 'has-error': hasError }]"
        >
            {{ errorMessage }}
        </p>
    </div>
</template>
<script>
export default {
    props: {
        options: {
            type: Array,
        },
        placeholder: {
            type: String,
        },
        tabindex: {
            type: Number,
            default: 0,
        },
        counterError: {
            type: Boolean,
            default: false,
        },
        directSearchAccessValue: {
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        showFlag: {
            type: Boolean,
            default: false,
        },
        showErrorRequired: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            selected: null,
            selectionMade: "",
            search: "",
            optionShown: false,
            errorMessage: this.$t("Please add a valid info"),
            hasError: this.counterError,
        };
    },
    methods: {
        checkLang() {
            let englishRegex = /[^A-Za-z0-9\s]/gi;
            if (englishRegex.test(this.search)) {
                this.search = null;
                this.$emit("notify", true);
                return;
            }
            this.$emit("notify", false);
        },
        test() {
            let l = this.$refs.optionList.classList;
            let h = this.$refs.head.classList;
            let i = this.$refs.indicator.classList;
            l.add("show");
            h.add("open-options");
            i.add("flip-up");
            this.labelUp();
            this.optionShown = true;
        },
        showOptions() {
            let l = this.$refs.optionList.classList;
            let h = this.$refs.head.classList;
            let i = this.$refs.indicator.classList;
            if (l.contains("show")) {
                this.closeOptions();
                this.optionShown = false;
            } else {
                l.add("show");
                h.add("open-options");
                i.add("flip-up");
                this.labelUp();
                this.optionShown = true;
            }
        },
        closeOptions() {
            this.$refs.optionList.classList.remove("show");
            this.$refs.head.classList.remove("open-options");
            this.$refs.indicator.classList.remove("flip-up");
            this.optionShown = false;
            if (this.selectionMade == "") {
                this.labelDown();
                this.hasError = true;
            }
        },
        setSelection(n, v, option) {
            this.selectionMade = n;
            this.$emit("value", this.selectionMade);
            this.$emit("raw", v);
            this.selected = option;
            this.$refs.optionList.classList.remove("show");
            this.$refs.head.classList.remove("open-options");
            this.$refs.indicator.classList.remove("flip-up");
            this.labelUp();
            this.optionShown = false;
            this.hasError = false;
        },
        labelUp() {
            this.$refs.head.classList.add("activated");
        },
        labelDown() {
            this.$refs.head.classList.remove("activated");
        },
        handleClicks(event) {
            if (!this.$el.contains(event.target)) {
                this.closeOptions();
            }
        },
        check() {
            if (this.selectionMade == "") {
                this.hasError = true;
            }
            return this.hasError;
        },
    },
    computed: {
        filtered() {
            let address = this.options;
            let st = new RegExp(this.search, "i");
            return address.filter((a) => {
                let { iso, nice_name } = a;
                if (iso.match(st) || nice_name.match(st)) {
                    return true;
                } else {
                    return false;
                }
            });
        },
    },
    mounted() {
        document.addEventListener("click", (event) => {
            this.handleClicks(event);
        });
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleClicks);
    },
    watch: {
        directSearchAccessValue: {
            immediate: true,
            deep: true,
            handler(newValue, oldValue) {
                if (this.directSearchAccessValue.nice_name) {
                    this.setSelection(
                        this.directSearchAccessValue.nice_name,
                        this.directSearchAccessValue.id
                    );
                } else {
                    this.search = this.directSearchAccessValue;
                }
            },
        },
    },
};
</script>
<style lang="scss" scoped>
$primary: #6174eb;
$error: #eb6174;
img {
    position: absolute;
    bottom: 7px;
    right: 7px;
}
.d-none {
    display: none;
}
.basic-select {
    position: relative;
    cursor: pointer;

    &:focus {
        outline: none;
    }

    .option-indicator {
        transition: 0.25s linear;
        font-size: 2.2em;
        display: inline-block;
        position: absolute;
        right: 5px;
        top: -10px;
    }

    .option-indicator.flip-up {
        transform: rotate(180deg);
    }

    .select-head {
        height: 30px;
        border-bottom: 1px solid #ddd;
        color: #444444;
        font-size: 1em;
        font-weight: 500;
        transition: 0.25s ease-out;
        box-sizing: border-box;
        padding: 7px 7px 7px 16px;
        text-align: left;
        position: relative;

        span {
            position: absolute;
            height: calc(100% - 8px);
            display: inline-block;
            background-color: white;
            width: 98%;
            top: 7px;
            left: 10px;
            z-index: 5;
        }

        input {
            position: absolute;
            transition: 0.25s linear;
            height: calc(100% - 5px);
            display: inline-block;
            width: 92%;
            font-size: 1em;
            font-weight: bold;
            top: 5px;
            left: 15px;
            border: none;
            outline: none;

            &:focus,
            &:active {
                border: none !important;
                outline: none !important;
            }
        }
    }

    .select-head.activated {
        border-color: $primary;
    }
    .select-head.open-options {
        border-bottom-color: transparent;
    }

    .select-head.has-error {
        border-color: $error !important;
    }

    ul {
        overflow-y: auto;
        position: absolute;
        top: 92%;
        left: 0;
        display: none;
        background-color: white;
        box-shadow: 0 5px 25px #d7d7d7;
        width: 100%;
        border-radius: 0 0 5px 5px;
        z-index: 25;

        li {
            text-align: left;
            padding: 7px 15px;
            border-top: 1px solid #d7d7d7;
            transition: 0.25s ease-out;
            color: #444444;

            &:first-child {
                border-top-color: transparent !important;
            }

            &:hover {
                background-color: #e6e6e6;
                color: black;
            }
        }
    }

    ul.show {
        display: block !important;
        max-height: 269px;
    }

    .error-message {
        transition: 0.25s linear;
        text-align: left;
        padding-left: 12px;
        font-size: 13px;
        color: $error;
        visibility: hidden;

        &.has-error {
            visibility: visible !important;
        }
    }
}
</style>
